import FOSSALogo from './FOSSALogo';
import { window } from '../../globals';

const CURRENT_YEAR = (new Date()).getFullYear();

const FooterText = () => (
  <footer className="footer">
    <div>
      Open source management powered by
      {' '}
      <span>
        <FOSSALogo
          color="rgba(62, 72, 91, 0.4)" // @fossaSlateBlue, lightened to 40%.
          width={46}
        />
      </span>
      , Inc. &copy; {CURRENT_YEAR}
    </div>
    <div>
      vers: {window.fossa_version} - revid: {window.fossa_revision.slice(0, 10)}
    </div>
  </footer>
);

export default FooterText;
